import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import AnimatedCardContent from "../../AnimatedCardContent";

const useStyles = makeStyles((theme) => ({
  title: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
}));

const UserEarningsInfo = ({ user, currentUser }) => {
  const classes = useStyles();
  return (
    <AnimatedCardContent>
      <Typography
        gutterBottom
        variant="h6"
        color="primary"
        className={classes.title}
      >
        <FormattedMessage id={currentUser.id === user.id ? "app.earnings.yourData" : "app.earnings.clientData"} />
      </Typography>
      <Typography
        gutterBottom
        variant="body2"
      >
        <FormattedHTMLMessage
          id="app.earnings.userName"
          values={{ name: user.name }}
        />
        {` (${user.id})`}
      </Typography>
      <Typography
        gutterBottom
        variant="body2"
      >
        <FormattedHTMLMessage id="app.email" />: {user.email}
      </Typography>
      <Typography
        gutterBottom
        variant="body2"
      >
        <FormattedHTMLMessage
          id="app.earnings.document"
          values={{
            documentId: user.documentId,
            documentType: user.documentType,
          }}
        />
      </Typography>
    </AnimatedCardContent>
  );
};

export default React.memo(UserEarningsInfo);
